module.exports = __webpack_public_path__ + "static/media/controller-status.8373fb2e.png";